export const auth =  {
  getUser: () => {return JSON.parse(sessionStorage.getItem('user'));},
  setUser: (user) => {sessionStorage.setItem('user', JSON.stringify(user))},
  logout: (navigate) => {
    sessionStorage.removeItem('user');
    navigate('/');
    window.location.reload();
  }
}
